export default "__VITE_ASSET__Cv0527VG__"